interface StatCardProps {
  title: string
  value: number | string
  icon: string
  color: 'blue' | 'green' | 'purple' | 'orange'
  loading?: boolean
}

function StatCard({ title, value, icon, color, loading = false }: StatCardProps) {
  return (
    <div className={`stat-card stat-card-${color}`}>
      <div className="stat-card-icon">
        <span>{icon}</span>
      </div>
      <div className="stat-card-content">
        <div className="stat-card-title">{title}</div>
        <div className="stat-card-value">
          {loading ? (
            <div className="stat-spinner"></div>
          ) : (
            value
          )}
        </div>
      </div>
    </div>
  )
}

export default StatCard
